import * as React from 'react';

import { translate } from '~l10n/client';
import Backbone from 'backbone';
import _ from 'underscore';

import view from 'AddNewStudentsView';
import modal from 'ModalController';
import model from 'RoomsModel';

function AddNewStudentsController() {
  _.extend(this, Backbone.Events);
}

AddNewStudentsController.prototype = {
  render: function (props) {
    props.controller = controller;
    props.model = model;

    modal.render({
      title: translate('Add Students'),
      content: React.createElement(view, props),
    });
  },

  validateStudent: function (field, value, indexPos, oldStudentID) {
    return model.validateStudent(field, value, indexPos, oldStudentID);
  },

  saveNewStudents: function (roomId) {
    return model.saveNewStudents(roomId);
  },

  cancelAddingNewStudents: function (roomName) {
    model.cancelAddingNewStudents(roomName);
  },

  addOneNewStudent: function () {
    return model.addOneNewStudent();
  },

  removeNewStudent: function (index) {
    return model.removeNewStudent(index);
  },

  closePopup: function () {
    modal.closeModal();
    model.updateRoomsList(); // This forces the view to refresh, so the click handlers work properly.
  },
};

let controller = new AddNewStudentsController();

controller.listenTo(model, 'modal:close', controller.closePopup);

module.exports = controller;
